import { useFullscreen } from "../../hooks/useFullscreen";
import { useT } from "../../i18n/LanguageProvider";
import { isNativeShell } from "../../platform/shell";
import { ShopFloorIcon } from "./ShopFloorIcon";

/**
 * Fixed top-right control to enter/exit browser fullscreen on shop floor tablets.
 *
 * Absent inside the tablet app (owner, 2026-09-10): the shell has no browser
 * chrome to escape, so the button would occupy the top-right corner of the
 * kiosk promising something that has already happened. It stays in the browser,
 * where a tablet or laptop running the kiosk page still needs it.
 */
export function ShopFloorFullscreenButton() {
  const { active, supported, toggle } = useFullscreen();
  const { t } = useT();

  if (isNativeShell()) return null;
  if (!supported) return null;

  return (
    <button
      type="button"
      className="shop-floor-fullscreen-btn"
      onClick={() => void toggle()}
      aria-pressed={active}
      aria-label={active ? t("fullscreen.exit") : t("fullscreen.enter")}
      title={active ? t("fullscreen.exit") : t("fullscreen.label")}
    >
      <ShopFloorIcon
        name={active ? "collapse" : "expand"}
        size={18}
        className="shop-floor-fullscreen-btn__icon"
      />
      <span className="shop-floor-fullscreen-btn__label">
        {active ? t("fullscreen.exitShort") : t("fullscreen.label")}
      </span>
    </button>
  );
}
